import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/locations/show.vue'

export default class extends Controller {
  static values = {
    locationId: String,
    accountId: String,
    csrfToken: String,
    availableServices: Array,
    defaultLocation: String
  }

  connect() {
    this.vue = createApp(App, {
      locationId: this.locationIdValue,
      accountId: this.accountIdValue,
      csrfToken: this.csrfTokenValue,
      availableServices: this.availableServicesValue,
      defaultLocation: this.defaultLocationValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
